import React from 'react';
import { IconButton, Stack } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { useTheme } from '@mui/material/styles';

/**
 * ZoomControls component renders zoom in and zoom out buttons for a viewer.
 *
 * Props:
 * - onZoomIn: Callback function triggered when zoom in button is clicked.
 * - onZoomOut: Callback function triggered when zoom out button is clicked.
 */
function ZoomControls({ onZoomIn, onZoomOut }) {
    const theme = useTheme();

    return (
        <Stack
            direction="row"
            spacing={1} // Space between buttons
            sx={{
                justifyContent: 'center',
                py: 0,
                bgcolor: 'transparent', // Remove background
                borderBottom: 'none',    // Optional: remove the border too
                zIndex: 10,
            }}
        >
            {/* Zoom out button */}
            <IconButton
                size="small"
                onClick={onZoomOut}
                aria-label="Zoom out"
                sx={{ p: 0.5, color: theme.palette.text.primary }}
            >
                <ZoomOutIcon fontSize="medium" />
            </IconButton>

            {/* Zoom in button */}
            <IconButton
                size="small"
                onClick={onZoomIn}
                aria-label="Zoom in"
                sx={{ p: 0.5, color: theme.palette.text.primary }}
            >
                <ZoomInIcon fontSize="medium" />
            </IconButton>
        </Stack>
    );
}

export default ZoomControls;
